import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Dashboard/Navbar";
import Sidebar from "../Dashboard/Sidebar";
import Footer from "../Footer";
function ManagerDashboard() {
  const SidebarList = [
    {
      category: "Dashboard",
      route: "",
    },
    {
      category: "View Publisher",
      subcategory: [
        { name: "Active", route: "publisher/active" },
        { name: "Inactive", route: "publisher/inactive" },
      ],
    },
    {
      category: "View Marketers",
      subcategory: [
        { name: "Active", route: "marketer/active" },
        { name: "Inactive", route: "marketer/inactive" },
      ],
    },
    // {
    //     category: "Modify Information",
    //     route: "/dashboard/manager/mod-info"
    // },
    {
      category: "Customer Support",
      subcategory: [
        { name: " Marketer Reset Password", route: "cus-sup/resetpassword" },
        { name: "Publisher Reset Password", route: "cus-sup/pubresetpassword" },
        { name: "Answer Ticket", route: "cus-sup/answerticket" },
      ],
    },
  ];

  const navMenu = [
    {
      link: "/",
      text: "Logout",
    },
  ];

  return (
    <>
      <Navbar navMenu={navMenu} />

      <div className="container-fluid">
        <div className="row h-90 ">
          <div className="col-2  shadow shadow-md">
            <Sidebar list={SidebarList} />
          </div>
          <div className="col-10">
            <Outlet />{" "}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ManagerDashboard;
